$(function() {
  var form = $('#create_customer');

  function validateRegisterForm() {
    form.validate({
      rules: {
        'customer[first_name]': {
          required: true,
        },

        'customer[last_name]': {
          required: true,
        },

        'customer[email]': {
          required: true,
          email: true,
          email_limit: true
        },

        'customer[password]': {
          required: true,
          rangelength: [8, 20],
          pwcheck: "Password Valid!",
        },

        'customer[password_confirmation]': {
          required: true,
          equalTo: "#password",
        },

        'customer[terms]': {
          required: true,
        },

        'customer[phone]': {
          required: true,
        },
        'customer[policy]': {
          required: true,
        },

        'customer[birthday]': {
          required: true,
          date: true,
          birthday_date: true,
        }
      },

      messages: {
        'customer[birthday]': {
          required: window.languages.field_required,
          date: "Please enter a valid date in the format MM/DD/YYYY",
          birthday_date: "Please enter a valid date in the format MM/DD/YYYY",
        },
        'customer[policy]': {
          required: window.languages.field_required_term_conditional,
        },
        'customer[email]': {
          email_limit: window.languages.email_limit,
        }
      }
    });

    $.validator.addMethod("pwcheck", function(value, element) {
      return /^[A-Za-z0-9\d=`~!@#$%^&*\(\)_\-+=\{\}\[\];:'"\\|<>,.?\/]*$/.test(value) // consists of only these
        && /[a-z]/.test(value) // has a lowercase letter
        && /[A-Z]/.test(value) // has a uppercase letter
        && /\d/.test(value) // has a digit
        && /[`~!@#$%^&*\(\)_\-+=\{\}\[\];:'"\\|<>,.?\/]/.test(value) //has one special character without space
    }, window.languages.invalid_password);

    $.validator.addMethod('birthday_date', function(value) {
      return value.match(/^(0[1-9]|1[012])[\/|-](0[1-9]|[12][0-9]|3[01])[\/|-](19\d\d|2\d\d\d)$/);
    });

    $.validator.addMethod('email_limit', function(value) {
      return value.split('@')[0].length <= 64;
    });
  }

  function handleSignUp(self) {
    var email = $('input[name="customer[email]"]').val();
    var formErrElm = $('.reg--error');
    var errElm = $('[data-err-message]');
    var errTitleElm = errElm.find('.reg--error--title');   

    var language_selected = $("#language-selected").text();

    if(language_selected != ""){
      language_selected = language_selected.toLowerCase();
    }
    else {
      language_selected = "en";
    }

    formErrElm.hide();
    errTitleElm.text('');
    errElm.css('background-color', '');

     // Intergrate GG Recaptcha V3
     grecaptcha.ready(function() {
      grecaptcha.execute(window.ggrecaptcha.site_key, {action: 'submit'}).then(function(token) {
        if (!token) {
          errElm.show();
          errTitleElm.text('Please check the reCAPTCHA.');
          return false;
        }
        else {
          formErrElm.hide();
          errTitleElm.text('');

          var postData = {
            "origin": "TH",
            "email": email,
            "is_term": true,
            "reCAPTCHA": token,
            "locale": language_selected + "_TH",
            "email_subcribe": $("#latest").prop('checked'),
            "phone": $('input[name="customer[phone]"]').val(),
            "bod": $('input[name="customer[birthday]"]').val(),
            "password": $('input[name="customer[password]"]').val(),
            "last_name": $('input[name="customer[last_name]"]').val(),
            "first_name": $('input[name="customer[first_name]"]').val(),
            "auto_registration": $("#autoregistration").prop('checked'),
            "signup_code": $('input[name="customer[sign_up_code]"]').val(),
            "confirm_password": $('input[name="customer[password_confirmation]"]').val()
          }
      
          self.addClass('button--loading');
          self.prop('disabled', true);
      
          formErrElm.hide();
          errTitleElm.text('');
          errElm.css('background-color', '');
      
          try {
            callAPIWithTokenRefresh('customers/sign_up', 'post', postData)
              .then(function(res){
                if (res.status) {
                  window.location.href = res.data;
        
                  return;
                }
        
                if(res.message === 'Account is disabled') {
                  $(form).submit();
                  return;
                } 
        
                if(res.message === "Account Exist - Please Login" 
                  || res.message === "Account Exist - Please Login." 
                  || res.message === "Account exist error"
                ) {
                  res.message = window.languages.accountExisted;
                }
        
                errElm.show();
                errTitleElm.text(res.message);
              })
              .catch(function(err) {
                console.log('fail', err);
              })
              .finally(function(e){
                self.removeClass('button--loading');
                self.prop('disabled', false);
              });
          } catch(err) {
            console.log("fail", err);
            self.removeClass('button--loading');
            self.prop('disabled', false);
          }
        };
      });
    });
  }

  validateRegisterForm();

  $("#btnSignUp").click(function (e) {
    e.preventDefault();

    if (!form.valid()) {
      return;
    }

    handleSignUp($(this));
  });
  
})
